<script>
import { addMinutes, getMinutes, setMinutes } from 'date-fns'
import formatDate, { formatRequestData } from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed } from '@state/helpers'


import BaseButtonDialog from '@components/BaseButtonDialog'

import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/zh-hk.js'

export default {
  page: {
    title: '排班',
    meta: [{ name: 'description', container: 'schedule' }],
  },
  components: {
    VueCal,
    BaseButtonDialog,
    ScheduleItem: () => lazyLoadComponent(import('./ScheduleItem')),
    CalendarItem: () => lazyLoadComponent(import('./components/CalendarItem')),
    ScheduleStaffFormAdd: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffFormAdd')),
  },
  props: {
    staffItems: {
      type: Array,
      required: true,
    },
    merchantProducts: {
      type: Array,
      required: true,
    },
    locationService: {
      type: String,
      default: ""
    },
    userRecords: {
      type: Number,
      default: 10
    },
    isSpace: {
      type: Boolean,
      default: false
    },
    // 看要打API的是哪種types
    fetchTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedDate: new Date(), // 選到的日期
      selectedItem: {},
      hasScheduleLength: '', // 此月已排班總日子數目
      currentStaffLocationIds: [],
      // productId: '',
      filterData: {
        productId: '',
        scheduleItemId: '',
      },
      visibleScheduleItem: false,
      splitLabels: [],
      staffsInSchedule: [],
      staffRoleType: [
        { label: '以角色查看', type: 'role' },
        // { label: '以人員查看', type: 'staff' },
      ], // 查看方式下拉選單
      checkType: 'role', // 查看方式選擇之後的v-model值
      events: [],
      calendarEvents: [],
      scheduleStaffs: this.staffItems,
      dialogVisible: false,
      dialogItem: {},
      dialogMode: 'edit', // edit 編輯, add 新增， view 預覽
      editable: {
        title: false,
        drag: false,
        resize: false,
        create: false,
        delete: false,
      },
      tryingFetchItemDetail: false,
      selectedStaffName: '',
      isFirst: true,
      roleSelectedStaff: '',
      initStatus: false,
      thisTimeProductFilterId: '', // 這次選到的分店
      staffOpenServiceTree: {}, // 代表由人事開啟的serviceTree
      thisTimeStaff: "", // 此次選到的職員
      thisStaffType: [], // 此職員所屬的type
      typesStaffIds: [], // 此種type的所有職員id
    }
  },
  computed: {
    ...merchantComputed,
    staffs() {
      return this.splitLabels.length
    },
    selectedDateString() {
      return this.selectedDate.format()
    },
    // 寬度要跟 vueCal 單一筆排班人員呈現一樣寬
    mirrorWidth() {
      return this.splitLabels.length * 300
    },
    staffLocations() {
      // 讓使用者選取所有分店
      // 下面是 if and return 如果要filter staff分店，要打開
      // if (!this.currentStaffLocationIds.length)
      return this.merchantProducts
    },
    roleSelectedStaffName() {
      let item = this.staffsInSchedule.find(item => item.id === this.roleSelectedStaff)
      if (item) {
        return item.name
      } else {
        return ''
      }
    },
    dateTimeSelected() {
      return this.selectedDateString
    },
    /**
     * @description 以人員排班 - for show List
     */
    forShowEventList() {
      if (this.roleSelectedStaff.length > 0) {
        return this.events.filter(item => item.split === this.roleSelectedStaff)
      } else {
        return []
      }
    },
    selectedMonth() {
      return this.selectedDate.getMonth() + 1
    },
  },
  watch: {
    checkType(nvl, ovl) {
      if (ovl === 'staff' && nvl === 'role') {
        this.roleSelectedStaff = ''
      }
    },
    "filterData.scheduleItemId": {
      handler(nvl) {
        if (nvl.length > 0) {
          const { name } = this.staffItems.find(item => item.id === nvl)
          this.thisTimeStaff = name && name.length > 0 ? name : ''
        } else {
          this.thisTimeStaff = ''
        }
      }
    }
  },
  async created() {
    this.initStatus = true
    if (this.$route.params.selectedDate !== undefined) {
      this.selectedDate = this.$route.params.selectedDate
    }
    await this.tryToFetchSchedule()
    let timeout = setInterval(() => {
      if (this.$refs['calRole'] !== undefined) {
        clearInterval(timeout)
        if (this.$refs.calRole) {
          this.handleSynchronizeScroll(this.$refs.calRole)
        }
        if (this.$refs.calStaff) {
          this.handleSynchronizeScroll(this.$refs.calStaff)
        }
      }
    }, 300)
    this.initStatus = false
  },
  mounted() {

  },
  beforeDestroy() {
    if (this.$refs.calRole) {
      this.handleSynchronizeScroll(this.$refs.calRole, false)
    }
    if (this.$refs.calStaff) {
      this.handleSynchronizeScroll(this.$refs.calStaff, false)
    }
  },
  methods: {
    openTab() {
      this.$emit('showOffOuterTab', {
        displayType: 'block',
        pageType: 'serviceOrStay'
      })
    },
    /**
     * @description 返回鍵按鈕做事
     */
    returnBtnFun() {
      this.openTab()
      this.visibleScheduleItem = false
    },
    showOffOuterTabFunc() {
      this.openTab()
    },
    /**
     * @description 計算本月多少天排班
     */
    computedScheduleValue() {
      let hasScheduleArr = this.calendarEvents.filter(data =>
        data.customInfo.isOpen &&
        data.end.includes(`${this.selectedMonth}-`)
      )
      this.hasScheduleLength = hasScheduleArr.length
    },
    modiHeader(date) {
      // day 週幾、objDate 日期、月份
      const transForm = ["日", "一", "二", "三", "四", "五", "六"]
      const [month, objDate, day] = [date.getMonth() + 1, date.getDate(), date.getDay()]
      return `週${transForm[day]} | ${month} / ${objDate}`
    },
    tryToFetchFromFather(location) {
      this.filterData.productId = location
      this.tryToFetchSchedule('filter')
    },
    /**
     * @description 找出space or prices的職員
     */
    async tryToFetchStaffList() {
      try {
        const result = await this.$store.dispatch('schedule/fetchStaff', {
          paginate: 0,
          type: this.fetchTypes[0]
        })
        return result.map(item => item.id)
      } catch (error) {
        console.error(error)
      }
    },
    async tryToFetchSchedule(type) {
      this.events = [] // 直接先清空vue-cal內的細節資料
      const { scheduleItems } = await this.$store.dispatch('schedule/fetchList', {
        date: this.selectedDateString,
        productId: this.filterData.productId,
        scheduleItemId: this.filterData.scheduleItemId,
        types: ['cosmetic', 'daycare'],
        scheduleItemTypes: this.fetchTypes,
        path: this.$route.path
      })
      if (this.checkType === 'staff') {
        const test = await this.$store.dispatch('schedule/fetchList', {
          date: this.selectedDateString,
          productId: this.filterData.productId,
          scheduleItemId: this.filterData.scheduleItemId,
          types: ['cosmetic', 'daycare'],
          scheduleItemTypes: this.fetchTypes,
          path: this.$route.path
        })
        scheduleItems.push(test.scheduleItems[0])
      }
      this.typesStaffIds = await this.tryToFetchStaffList()
      this.filterSplitLabels(scheduleItems)
      this.filterEvents(scheduleItems)
      this.filterScheduleStaffs(scheduleItems) // show出哪些職員是還可以被排班的

      if (type === 'filter') {
        await this.tryToFetchCurrentMonthly()
      }
      if (this.initStatus) this.computedScheduleValue()
    },
    /**
     * @description 取得預設排班的店id
     */
    getLocationId(items) {
      if (items.length > 0 && this.thisTimeProductFilterId.length === 0) {
        const { products } = items[0]
        this.$emit('setLocationId', products[0].id)
        this.thisTimeProductFilterId = products[0].id
      }
    },
    async tryToStoreItem(staff) {
      await this.$store.dispatch('schedule/storeItem', {
        date: this.selectedDateString,
        itemId: staff.id,
      })
      if (this.locationService) {
        this.filterData.productId = this.locationService
      }
      this.filterData.scheduleItemId = ''
      await this.tryToFetchSchedule()
    },
    async tryToFetchCurrentMonthly() {
      if (this.$refs['sm-cal']) {
        const { firstCellDate, lastCellDate } = this.$refs['sm-cal'].getViewInfo()
        const startDate = formatRequestData(firstCellDate)
        const endDate = formatRequestData(lastCellDate)
        await this.tryToFetchMonthly({ startDate, endDate, scheduleItemId: this.filterData.scheduleItemId })
      }
    },
    /**
     * @description 過濾出尚未加入班表上的人員
     */
    async filterScheduleStaffs(list) {
      try {
        // 因為有可能人員停權後要即時更新，所以這邊要打一次fetchStaff API
        let staffs = []
        let staffItems = []
        let productName = ''
        if(!this.initStatus){
          staffs = await this.$store.dispatch('schedule/fetchStaff', { paginate: 0 })
        }
        staffItems = this.initStatus ? [...this.staffItems] : [...staffs]
        if (this.locationService.length > 0) {
          const { name } = this.merchantProducts.find(item => item.id === this.locationService)
          productName = name
        }
        const itemIds = list.map((item) => item.id) // 已經被排上的staff有哪些
        this.scheduleStaffs = [
          ...staffItems.filter((staff) => {
            if (this.locationService.length > 0) {
              return (
                !itemIds.includes(staff.id) && // 排除已經被排上的id
                this.typesStaffIds.includes(staff.id) && // 排除非此type的id（如prices or spaces）
                staff.storeTitles.includes(productName) &&  // 排除非此分店id
                staff.userGroupIds.includes(11) && // 排除非排班人員id
                staff.block === 0 // 排除停權的角色
              )
            } else {
              return (
                !itemIds.includes(staff.id) && // 排除已經被排上的id
                this.typesStaffIds.includes(staff.id) && // 排除非此type的id（如prices or spaces）
                staff.userGroupIds.includes(11) && // 排除非排班人員id
                staff.block === 0 // 排除停權的角色
              )
            }
          }),
        ]
      } catch (error) {
        console.error(error.message)
      }
    },
    filterSplitLabels(list) {
      const splits =
        list
          .filter(item => item.state === 1)
          .map((item) => {
            let storeName = ''
            if (item.scheduleDetails.length > 0) {
              storeName = item.scheduleDetails[0].storesTitle.join(', ')
            }
            return {
              id: item.id,
              name: `${item.name}${item.scheduleDetails.length ? ` - ${storeName}` : '（無排班）'}`,
              canDelete: item.scheduleDetails.length === 0,
            }
          })
      this.staffsInSchedule = [...splits]
      this.splitLabels = [...splits, { type: 'create' }]
    },
    filterEvents(list) {
      const eventList = []
      list.forEach((item) => {
        item.scheduleDetails.forEach((event) => {
          const isUsedByBranchStore = event.isFiltered === 1
          eventList.push({
            start: event.startDate,
            end: event.endDate,
            split: item.id,
            customInfo: { ...event },
            disabled: isUsedByBranchStore,
            background: isUsedByBranchStore,
          })
        })
      })
      this.events = eventList
    },
    async onCellClick({ date, split: itemId }) {
      // 新增排班
      if (typeof itemId === 'number') return
      await this.tryToFetchStaffDetail(itemId, date)
      this.getSelectedStaffName(itemId)
      this.$emit('showOffOuterTab', {
        displayType: 'none',
        pageType: 'serviceOrStay'
      })
      this.$set(this.selectedItem, 'staffOpenServiceTree', { ...this.staffOpenServiceTree, type: 'add' })
      this.visibleScheduleItem = true
    },
    async onEventClick(event, e) {
      // 編輯排班
      if (event.disabled) {
        return
      }

      const staffId = event.split
      const scheduleId = event.customInfo.id

      this.tryingFetchItemDetail = true

      await this.tryToFetchStaffDetail(staffId, event.start, true)
      this.selectedItem = await this.$store.dispatch('schedule/fetchItemDetail', scheduleId)
      this.getSelectedStaffName(staffId)
      this.$set(this.selectedItem, 'staffOpenServiceTree', { ...this.staffOpenServiceTree, type: 'edit' })
      this.visibleScheduleItem = true
      this.tryingFetchItemDetail = false
      this.$emit('showOffOuterTab', {
        displayType: 'none',
        pageType: 'serviceOrStay'
      })
      e.stopPropagation()
    },
    async fetchEvents() {
      await this.tryToFetchSchedule()
    },
    getStartEndTime(date) {
      const time = getMinutes(date)
      let startTime = ''
      switch (true) {
        case (time < 15):
          startTime = setMinutes(date, 0)
          break;
        case (time < 30 && time >= 15):
          startTime = setMinutes(date, 15)
          break;
        case (time < 45 && time >= 30):
          startTime = setMinutes(date, 30)
          break;
        case (time < 60 && time >= 45):
          startTime = setMinutes(date, 45)
          break;
      }
      const endTime = addMinutes(startTime, 15)
      return { startTime: formatDate(startTime, 'time'), endTime: formatDate(endTime, 'time') }
    },
    createStaff() {
      this.openDialog('add')
    },
    openDialog(mode, itemData) {
      this.dialogVisible = true
      this.dialogMode = mode
      this.$set(this.$data, 'dialogItem', itemData)
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async onItemStored() {
      await this.tryToFetchSchedule()
      await this.tryToFetchCurrentMonthly()
      this.visibleScheduleItem = false
    },
    getSelectedStaffName(itemId) {
      this.splitLabels.some((label) => (label.id === itemId ? (this.selectedStaffName = label.name) : false))
    },
    async onViewChange(viewInfo) {
      if (viewInfo.view !== 'month') return
      await this.tryToFetchMonthly({
        startDate: formatRequestData(viewInfo.firstCellDate),
        endDate: formatRequestData(viewInfo.lastCellDate),
        scheduleItemId: this.filterData.scheduleItemId
      })
    },
    async tryToFetchMonthly(date) {
      const list = await this.$store.dispatch('schedule/fetchMonthly', { ...date })
      this.calendarEvents = list.map((item) => ({
        start: item.date,
        end: item.date,
        customInfo: {
          ...item,
        },
      }))
      this.computedScheduleValue()
    },
    async onRenderedCalendarItem() {
      await this.tryToFetchCurrentMonthly()
    },
    handleSynchronizeScroll(el, bind = true) {
      const $header = el.$el.getElementsByClassName('vuecal__header')[0]
      const $body = el.$el.querySelector('[row]')
      const $scrollbar = this.$el.querySelector('#custom-scrollbar')

      let animationFrameId = null

      const handleHeaderScroll = () => {
        $body.scrollLeft = $header.scrollLeft
        $scrollbar.scrollLeft = $header.scrollLeft
      }
      const handleBodyScroll = () => {
        $header.scrollLeft = $body.scrollLeft
        $scrollbar.scrollLeft = $body.scrollLeft
      }

      const handleScrollbarScroll = () => {
        $header.scrollLeft = $scrollbar.scrollLeft
        $body.scrollLeft = $scrollbar.scrollLeft
      }

      if (bind) {
        const scrollHeaderHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleHeaderScroll()
            animationFrameId = null
          })
        }


        const scrollBodyHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleBodyScroll()
            animationFrameId = null
          })
        }

        const scrollbarScrollHandler = () => {
          if (animationFrameId) return
          animationFrameId = requestAnimationFrame(() => {
            handleScrollbarScroll()
            animationFrameId = null
          })
        }

        $header.addEventListener('scroll', scrollHeaderHandler)
        $body.addEventListener('scroll', scrollBodyHandler)
        $scrollbar.addEventListener('scroll', scrollbarScrollHandler)
      } else {
        $header.removeEventListener('scroll', handleHeaderScroll)
        $body.removeEventListener('scroll', handleBodyScroll)
        $scrollbar.removeEventListener('scroll', handleScrollbarScroll)
      }
    },
    handleSynchronizeScroll2(el, bind = true) {
      const $header = el.$el.getElementsByClassName('vuecal__header')[0]
      const $body = el.$el.querySelector('[row]')
      const $scrollbar = this.$el.querySelector('#custom-scrollbar')
      if (bind) {
        $header.addEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.addEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.addEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      } else {
        $header.removeEventListener('scroll', () => {
          $body.scrollLeft = $header.scrollLeft
          $scrollbar.scrollLeft = $header.scrollLeft
        })
        $body.removeEventListener('scroll', () => {
          $header.scrollLeft = $body.scrollLeft
          $scrollbar.scrollLeft = $body.scrollLeft
        })
        $scrollbar.removeEventListener('scroll', () => {
          $header.scrollLeft = $scrollbar.scrollLeft
          $body.scrollLeft = $scrollbar.scrollLeft
        })
      }
    },
    /**
     * @description 人事 -> 點選vue cal下去要撈資料的地方
     */
    async tryToFetchStaffDetail(id, date, onlyUpdateCurrentStaffLocationIds = false) {
      const month = new Date(date).getMonth() + 1
      const year = new Date(date).getFullYear()
      const { storeIds, serviceCategoryIds, productPriceIds, maxCollision, serviceIds, types } = await this.$store.dispatch('schedule/fetchStaffDetail', {
        id,
        date: `${year}-${month}`
      })
      this.thisStaffType = types
      this.staffOpenServiceTree = {
        serviceCategoryIds,
        serviceIds,
        storeIds,
        searchTypes: types
      }
      if (!onlyUpdateCurrentStaffLocationIds) {
        this.selectedItem = {
          itemId: id,
          ...this.getStartEndTime(date),
          productIds: storeIds,
          serviceCategoryIds,
          serviceIds: productPriceIds,
          maxCollision
        }
      }
      this.currentStaffLocationIds = [...storeIds]
    },
    async tryToRemoveItem(id) {
      try {
        await this.$store.dispatch('schedule/deleteScheduleItem', {
          date: this.selectedDateString,
          itemId: id,
        })
        // this.isFirst=true
        await this.tryToFetchSchedule()
      } finally {
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.page" style="margin-bottom:0">
      <BaseTableSearch v-if="!visibleScheduleItem" v-slot="{ fields }" hide-action :hideReset="true"
        :default-value.sync="filterData" :border="true" @reset="tryToFetchSchedule('filter')"
        @tryToFetchList="tryToFetchSchedule" :class="$style.topSearch">
      
        <el-select v-model="checkType" @change="tryToFetchSchedule('filter')" class="is-round is-border"
          style="margin-right: 10px;">
          <el-option label="請選擇查看方式" value></el-option>
          <el-option v-for="(item, index) in staffRoleType" :key="index" :label="item.label" :value="item.type">
          </el-option>
        </el-select>

        <el-select v-model="filterData.scheduleItemId" @change="tryToFetchSchedule('filter')">
          <el-option label="請選擇人員" value></el-option>
          <el-option v-for="(staff, index) in staffsInSchedule" :key="index" :label="staff.name" :value="staff.id">
          </el-option>
        </el-select>

        <!-- 未來有機會打開，先不要刪 -->
        <!-- <div :class="$style.topBtn">
          <el-form-item>
            <el-button class="is-round" plain>
              <BaseIcon name="upload" icon-style="fal" /> 班表匯入
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="is-round" plain>
              <BaseIcon name="file-export" /> 班表匯出
            </el-button>
          </el-form-item>
        </div> -->
      </BaseTableSearch>
      <div v-if="checkType.length > 0 && !visibleScheduleItem && !tryingFetchItemDetail" :class="$style.filterStatus">
        <template v-if="checkType === 'role'">
          <p><span class=" filter">排班篩選：</span><span class="role">以角色 -{{ thisTimeStaff }} 美容師</span></p>
        </template>
        <template v-if="checkType === 'staff' && !visibleScheduleItem && !tryingFetchItemDetail">
          <p><span class="filter">排班篩選：</span><span class="role">以人員 - {{ roleSelectedStaffName }}美容師</span></p>
        </template>
      </div>
      <div v-if="visibleScheduleItem" :class="$style.returnBtn">
        <el-button class="is-round" @click="returnBtnFun">
          <BaseIcon name="arrow-left" />
          返回
        </el-button>
        <h3>編輯人員排班時段</h3>
      </div>
      <el-card v-loading="tryingFetchItemDetail" element-loading-text="取得排班資訊中" shadow="never"
        :class="$style['card-wrapper']" style="margin-bottom:0">
        <transition-group :name="visibleScheduleItem ? $style.zoom : $style['zoom-reverse']">
          <div v-show="!visibleScheduleItem" :key="'vue-cal'" class="vue-cal-layout">
            <div>
              <CalendarItem v-slot="{ data: { cell, events } }" ref="sm-cal" :selected-date.sync="selectedDate"
                :calendar-events="calendarEvents" @view-change="onViewChange" @rendered="onRenderedCalendarItem">
                <span class="vuecal__cell-date" :class="events[0] && events[0].customInfo.isOpen ? 'is-available' : ''">{{
                  cell.content
                }}</span>
              </CalendarItem>
              <el-divider></el-divider>
              <p> {{ selectedMonth }}月 | 已排班：{{ hasScheduleLength }} 日 </p>
            </div>
            <div class="schedule-wrap">
              <!-- 以人員查看（要改這個） -->
              <VueCal v-if="false" ref="calStaff" :selected-date="selectedDate"
                class="full-cal vuecal--full-height-delete" :class="[$style.schedule, $style[`split-labels-${staffs}`]]"
                :time-from="6 * 60" :time-to="24 * 60" :disable-views="['years', 'year', 'week', 'day', 'month']"
                :hide-title-bar="true" :sticky-split-labels="true" :events="forShowEventList"
                :on-event-click="onEventClick" :editable-events="editable" :time-step="15" :time-cell-height="50">
                <template v-slot:weekday-heading="param">
                  <div :class="$style.weekendHeader">
                    {{ modiHeader(param.heading.date) }}
                  </div>
                </template>
                <!-- 行事曆body -->
                <template v-slot:event="{ event }">
                  <template v-if="event.disabled">
                    <div class="disabled"></div>
                  </template>
                  <template v-else>
                    <div class="title">
                      <div class="time Jost">
                        <p>{{ event.start.format('HH:mm') + ' ~ ' + event.end.format('HH:mm') }}</p>
                        <p class="state" :class="{ 'is-close': event.customInfo.state === 0 }">{{ event.customInfo.state
                          ?
                          '開放中' : '未開放'
                        }}</p>
                      </div>
                      <span class="cycle">{{ event.customInfo.repeat }}</span>
                    </div>
                    <p class="service">服務項目</p>
                    <div class="listItem"><span class="label">可服務項目：</span><span class="text">{{ `
                        ${event.customInfo.servicesCount} 種`
                    }}</span></div>
                    <div class="listItem"><span class="label">可服務地點：</span><span class="text">{{
                      event.customInfo.products.map(({ title }) => title).join('、')
                    }}</span></div>
                    <el-button class="is-fullwidth is-round editSchedule" style="margin-top: 10px; padding: 8px">編輯排班
                    </el-button>
                  </template>
                </template>
              </VueCal>

              <!-- 以角色查看 -->
              <VueCal v-show="checkType !== 'staff'" ref="calRole" class="full-cal vuecal--full-height-delete"
                :class="[$style.schedule, $style[`split-labels-${staffs}`]]" hide-weekends="hide-weekends"
                active-view="day" locale="zh-hk" :selected-date="selectedDate" :time-from="0 * 60" :time-to="24 * 60"
                :split-days="splitLabels" :sticky-split-labels="true" :editable-events="editable" :events="events"
                :on-event-click="onEventClick" :time-step="15" :disable-views="['years', 'year', 'week', 'day', 'month']"
                :hide-title-bar="true" :time-cell-height="50" :snap-to-time="1" @cell-click="onCellClick"
                @view-change="fetchEvents">
                <!-- 行事曆header-->
                <template v-slot:split-label="{ split }">
                  <el-dropdown v-if="split.type === 'create'" trigger="click">
                    <el-button class="isStyleSelectStaff">選擇人員
                      <BaseIcon icon-style="fal" name="chevron-down" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown" :class="$style['schedule-dropdown']">
                      <el-dropdown-item :disabled="currentMerchant.plan.accounts < userRecords"
                        @click.native="createStaff">
                        <BaseIcon name="plus" /> 新增人員
                      </el-dropdown-item>
                      <el-dropdown-item v-for="(staff, index) in scheduleStaffs" :key="`staff-${index}`"
                        @click.native="tryToStoreItem(staff)">
                        {{ staff.name }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <el-button v-if="split.type !== 'create' && !split.canDelete" style="pointer-events: none"
                    class="isStyleSelectStaff">
                    {{ split.name }}
                  </el-button>
                  <div v-if="split.type !== 'create' && split.canDelete" class="isStyleSelectStaff">
                    {{ split.name }}
                    <div class="cancelBtn" @click="tryToRemoveItem(split.id)">
                      <BaseIcon icon-style="fal" name="times" />
                    </div>
                  </div>
                </template>

                <!-- 行事曆body -->
                <template v-slot:event="{ event }">
                  <template v-if="event.disabled">
                    <div class="disabled"></div>
                  </template>
                  <template v-else>
                    <div class="title">
                      <div class="time Jost">
                        <p>{{ event.start.format('HH:mm') + ' ~ ' + event.end.format('HH:mm') }}</p>
                        <p class="state" :class="{ 'is-close': event.customInfo.state === 0 }">{{ event.customInfo.state
                          ?
                          '開放中' : '未開放'
                        }}</p>
                      </div>
                      <span class="cycle">{{ event.customInfo.repeat }}</span>
                    </div>
                    <p class="service">服務項目</p>
                    <div class="listItem"><span class="label">可服務項目：</span><span class="text">{{ `
                        ${event.customInfo.servicesCount} 種`
                    }}</span></div>
                    <div class="listItem"><span class="label">可服務地點：</span><span class="text">{{
                      event.customInfo.products.map(({ title }) => title).join('、')
                    }}</span></div>
                    <el-button class="is-fullwidth is-round editSchedule" style="margin-top: 10px; padding: 8px">編輯排班
                    </el-button>
                  </template>
                </template>
              </VueCal>
              <!-- VueCal沒有scrollbar，要自製 -->
              <div id="custom-scrollbar" :class="$style['custom-scrollbar']">
                <div :style="`height:inherit;width: ${mirrorWidth}px;`"></div>
              </div>
            </div>
          </div>
          <ScheduleItem v-if="visibleScheduleItem" :key="'ScheduleItem'" :default-value="selectedItem"
            :staff-name="selectedStaffName" :day="selectedDateString" :locations="staffLocations"
            @cancel="visibleScheduleItem = false" @store="onItemStored" @returnBtn="returnBtnFun"
            @showOffOuterTab="showOffOuterTabFunc" @resetTab="openTab"></ScheduleItem>
        </transition-group>
      </el-card>
      <div v-if="visibleScheduleItem" style="margin-top:60px"></div>
    </div>

    <BaseButtonDialog width="1000px" only-dialog title="新增人員" :dialog-visible.sync="dialogVisible" floating>
      <ScheduleStaffFormAdd :default-value="dialogItem" :fetch-types="fetchTypes" access-type="schedule" is-dialog @store="tryToStoreItem"
        @close="closeDialog" />
    </BaseButtonDialog>
  </div>
</template>
<style lang="scss">
@import '@src/design/vuecal-override.scss';

.schedule-wrap {
  margin-left: 20px;
  flex: 1 0 auto;
  width: 300px;
  height: calc(100vh - 350px);

  @media screen and (max-height: 850px) {
    height: 540px !important;
  }

  @media screen and (min-height: 851px) and (max-height: 900px) {
    height: 555px !important;
  }

  position: relative;

  @media screen and (max-height: 850px) {
    height: 540px !important;
  }

  @media screen and (min-height: 851px) and (max-height: 900px) {
    height: 555px !important;
  }

  @include max-sm {
    width: auto;
    height: auto;
  }

  // .vuecal__flex {
  //   @include max-sm {
  //     overflow: hidden !important;
  //   }
  // }

  .vuecal__time-column {
    @include max-sm {
      height: auto !important;
    }
  }
}

.vue-cal-layout {
  display: flex;
}
</style>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
$min-split-width: 200px;

@for $i from 1 through 10 {
  .split-labels-#{$i} {
    overflow-x: hidden;

    :global {
      .vuecal__header {

        // width: $min-split-width * $i + 42px;
        .vuecal__split-days-headers {
          height: auto !important;
          border-top: 0 !important;
          border-bottom: 0 !important;
          margin-left: 3em;
          box-shadow: inset 0px 0px 0px 0.5px rgba(0, 0, 0, 0.08);
          width: auto;
        }
      }

      .vuecal__body {
        // width: $min-split-width * $i + 42px !important;
      }
    }
  }
}

.schedule-dropdown {
  width: 299.5px;
  margin-top: 3px !important;
  max-height: 500px;
  overflow-y: auto;

  :global {
    .popper__arrow {
      display: none;
    }
  }
}

.schedule {
  // border-radius: 4px;
  box-shadow: inherit !important;
  position: relative;

  :global {
    .vuecal__header {
      width: auto;
      overflow-x: scroll;
      min-height: 44px;
      margin-left: 57px;

      // overflow-x: hidden;
      // for 以角色查看
      .vuecal__split-days-headers {
        // border-top: 1px solid $color-line-dark;
        // border-bottom: 1px solid $color-line-dark;
        margin-left: 0;
        display: inline-flex;

        .day-split-header {
          width: 300px;
          height: 44px;

          .isStyleSelectStaff {
            background: rgb(249, 249, 251);
            height: 43px;
            width: 100%;
            text-align: left;
            position: relative;
            border: 0;
            padding: 12px 20px;
            font-size: 14px;
            border-bottom: 1px solid $color-line-dark;
          }

          >.el-button span {
            white-space: nowrap;
            text-overflow: ellipsis;
            width: auto;
            display: block;
            overflow: hidden;
          }

          .el-dropdown {
            width: 100%;

            button {
              // border: none;
              width: 100%;

              span {
                display: flex;
                justify-content: space-between;
              }
            }
          }

          border-top: 1px solid $color-line-dark;
          border-left: 1px solid $color-line-dark;
        }
      }

      // for 以人員查看 header
      .vuecal__weekdays-headings {
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        margin-left: 0;
        display: inline-flex;
        padding: 0;

        .vuecal__heading {
          width: 300px;
          background-color: #F9F9FB;
          height: 44px;

          &.vuecal__heading {
            border-left: 1px solid rgba(198, 198, 186, 0.7);
          }
        }
      }
    }

    .vuecal__time-cell-line::before {
      left: 65px !important;
      width: 3000px;
    }

    .vuecal__body {
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 55px;
        width: 100%;
        height: 1px;
        background: rgba(0, 0, 0, 0.08);
      }

      .vuecal__bg>.vuecal__flex {
        overflow-x: scroll;
        display: block;

        .week-view {
          .vuecal__flex {
            flex-wrap: nowrap;
            overflow-x: inherit;
          }
        }

        .vuecal__time-column {
          position: absolute;
          height: 4800px;
          left: -8px;
          background: #fff;
          z-index: 14;
          padding-top: 40px;
          margin-top: -40px;
          width: 60px;

          .vuecal__time-cell {
            background: white;

            &:last-child {
              box-shadow: 0px 1px white;
            }
          }
        }

        .vuecal__cells {
          height: 4800px;
          padding-left: 4rem;
          padding-left: 57px;

          .vuecal__cell {
            width: auto;
            justify-content: inherit;
          }
        }
      }
    }

    .vuecal__cell-content {
      // width: 200px;
      max-width: 300px;
      min-width: 300px;
      cursor: pointer;

      .vuecal__cell-events {
        overflow-x: hidden;

        .vuecal__event {
          // width: 50% !important;
        }
      }

      .vuecal__no-event {
        display: none;
      }

      .vuecal__event {
        box-shadow: inset 0 0 0 2px #f2eae6;
        padding: 20px;
        text-align: left;
        background-color: #f8f4f2;

        .service {
          font-size: 14px;
          color: $color-secondary;
          margin: 12px auto;
        }

        .editSchedule {
          background-color: $color-primary;
          color: white;
        }

        .listItem {
          margin: 6px auto;

          .label {
            color: $color-text-light;
          }

          .text {
            color: $color-secondary;
          }
        }

        .title {
          display: flex;
          flex-direction: column;
          margin-bottom: 24px;
          border-bottom: 1px solid #f2a67f;
          padding-bottom: 24px;

          .time {
            font-size: 15px;
            line-height: 18px;
            font-weight: 500;
            display: flex;
            justify-content: space-between;

            @include max-sm {
              height: auto !important;
              // background-color: red;
            }

            .state {
              margin-left: 13px;
              color: #26C395;
              font-size: 14px;
              box-shadow: 0px 0px 0 1px #26C395;
              border-radius: $border-radius;
              padding: 3px 10px;
              font-weight: normal;

              &.is-close {
                color: $color-primary;
                box-shadow: 0px 0px 0 2px $color-primary;
              }
            }

          }

          .cycle {
            color: $color-primary;
            font-weight: 400;
          }

          svg {
            color: white;
            background: green;
            padding: 6px;
            font-size: 30px;
            border-radius: 6px;
            padding-left: 8px;
          }
        }

        &.vuecal__event--background {
          // margin-top: 2px;
          padding: 0;
          z-index: 3;

          .disabled {
            height: inherit;
            background: repeating-linear-gradient(45deg, lightgrey 0px, lightgrey 2px, #f2f2f2 0px, #f2f2f2 7px);
            opacity: 0.5;
            box-shadow: inset 0 -2px white;
            pointer-events: none;
          }
        }
      }

      &+.vuecal__cell-content {
        border-left: 1px solid rgba(0, 0, 0, 0.08);
      }
    }
  }
}

:global() {
  :local(.schedule) {
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 55px;
      width: calc(100% - 9px);
      height: 1px;
      background: rgb(0 0 0 / 0.08);
    }
  }
}

.card-wrapper {
  background-color: white;
  min-height: 77vh;

  @include max-sm {
    overflow-x: scroll;
  }

  :global {
    .el-card__header {
      background-color: #eeeeee;
    }

    .el-card__body {
      position: relative;
      padding: 25px;
    }
  }
}

.filter {
  :global {
    input {
      height: 40px;
      background: white;
      border: 2px solid lightgray;
      border-radius: 9px;
    }

    i,
    input::placeholder {
      color: #333 !important;
    }
  }
}

.custom-scrollbar {
  position: absolute;
  bottom: 0;
  height: 16px;
  left: 0;
  right: 0;
  margin-left: 55px;
  margin-right: -15px;
  bottom: -15px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: block;
    height: 16px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #dcdad8;
    box-shadow: inset 0px 0px 0px 4px rgb(245 245 245 / 1);
  }

  &::-webkit-scrollbar-track {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
}

%zoom_leaving {
  position: absolute;
  width: 878px;
}

.zoom {
  &:global(-enter) {
    opacity: 0;
    transform: scale(1.1);
  }

  &:global(-enter-active) {
    transition-delay: 0.15s !important;
  }

  &:global(-enter-active),
  &:global(-leave-active) {
    transition: all 0.3s;
  }

  &:global(-leave) {
    @extend %zoom_leaving;
  }

  &:global(-leave-to) {
    @extend %zoom_leaving;
    opacity: 0;
    transform: scale(0.9);
  }

  &-reverse {
    &:global(-enter) {
      opacity: 0;
      transform: scale(0.9);
      @extend %zoom_leaving;
    }

    &:global(-enter-active) {
      transition-delay: 0.15s !important;
    }

    &:global(-enter-to) {
      @extend %zoom_leaving;
    }

    &:global(-enter-active),
    &:global(-leave-active) {
      transition: all 0.3s;
    }

    &:global(-leave) {
      @extend %zoom_leaving;
    }

    &:global(-leave-to) {
      @extend %zoom_leaving;
      opacity: 0;
      transform: scale(1.1);
    }
  }
}


.topSearch {
  background-color: $color-body-bg;

  .topBtn {
    display: flex;

    :global {
      .el-form-item {
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  :global {
    .el-form-item .el-form-item__content .el-input__inner {
      border: 1px solid $color-line;
    }
  }
}

.filterStatus {
  width: auto;
  height: 80px;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 18px 20px;
  margin-bottom: -18px;

  :global {
    .filter {
      color: $color-text-light;
    }

    .role {
      color: $color-secondary;
    }

    .el-select {
      width: 237px;
      margin-right: 36px;
    }
  }
}

.showByDate {
  width: 100%;
  height: 44px;
  background-color: #F9F9FB;
  padding: 14px 20px;
  text-align: center;
}

:global {
  .vuecal__heading {
    width: 300px;
  }
}

.returnBtn {
  background-color: $color-body-bg;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 15px;

  :global {
    .el-button {
      width: 100px;
      height: 44px;
      margin-right: 20px;
    }
  }
}
</style>
